import React from 'react';
import { Button } from 'antd';
import emiter, { _EVENTS } from '../../../../events';
import BaseInfo from './BaseInfo';
import BookInfo from './BookInfo';
import RemarkDetail from './RemarkDetail';
import DriverInfo from './DriverInfo';
import OtherInfo from './OtherInfo';
import HandlerDetail from './HandlerDetail';
import { useOrderList } from 'hooks/order-management/order-list';
import SPButton from "../../../carRental/base/SPButton";

interface IComponentProps {
  data?: any;
  enums?: any;
  permission?: any;
}

const OrderInfo: React.FC<IComponentProps> = props => {

  const { data, enums, permission } = props || {};

  const btnStyle: React.CSSProperties = { margin: '0 12px 20px 0' };

  const { arrangeCarModalOpen, arrangeDriverModalOpen, remarkModalOpen, pickupCar, returnCar } = useOrderList();

  const handleArrangeCarClick = () => {
    arrangeCarModalOpen(data?.order_info || {});
  };

  const handleArrangeDriverClick = () => {
    arrangeDriverModalOpen(data?.order_info || {});
  };

  const handleRemarkClick = () => {
    remarkModalOpen(data?.order_info || {});
  };

  // const handlePickupClick = () => {
  //   pickupCar(data?.order_info);
  // };

  // const handleReturnClick = () => {
  //   returnCar(data?.order_info);
  // }


  return (
  <>
    <div>
      {data?.order_info?.order_status <= 1 && (
        <>
          <SPButton permissionKey='arrange-vehicle' permission={permission} type="primary" style={btnStyle} disabled={false} onClick={handleArrangeCarClick}>
            { data?.order_info?.veh_info?.veh_code ? '改排车' : '排车' }
          </SPButton>
        </>
      )}
      {data?.order_info?.order_status <= 2 && data?.order_info?.veh_info?.veh_plate && (data?.order_info?.pickup_info.type !== 3 || data?.order_info?.return_info.type !== 3) && (
        <>
          <SPButton permissionKey='arrange-driver' permission={permission} type="primary" style={btnStyle} disabled={false} onClick={handleArrangeDriverClick}>
            排司机
          </SPButton>
        </>
      )}
      <SPButton permissionKey='remark-add' permission={permission} type="primary" style={btnStyle} disabled={false} onClick={handleRemarkClick}>
        订单备注
      </SPButton>
      {/* <Button type="primary" style={btnStyle} disabled={false} onClick={handlePickupClick}>
        取车
      </Button>
      <Button type="primary" style={btnStyle} disabled={false} onClick={handleReturnClick}>
        还车
      </Button> */}
    </div>
    <BaseInfo data={data} enums={enums} />
    <BookInfo data={data} enums={enums} />
    <RemarkDetail data={data} />
    <DriverInfo data={data} />
    <OtherInfo data={data} />
    <HandlerDetail data={data} />
  </>
  );
};

export default OrderInfo;
